const fr = {
    "front.faq.chat.title": "POSER UNE QUESTION",
    "front.faq.chat.description": "assistance instantanée pour les clients du restaurant",
    "front.faq.chat.welcome": "Vous pouvez poser une question directement ici.",
    "front.faq.chat.placeholder": "message",
    "front.faq.chat.send": "envoyer",
    "front.faq.chat.unsupportedLanguage": "Désolé, ce chat ne prend actuellement en charge que l’anglais et l’allemand.",
    "front.faq.chat.fallback": "Merci pour votre message. Pour le moment, je peux seulement répondre aux questions fréquentes. Veuillez nous contacter directement pour plus d’informations.",
    "front.faq.chat.answer.hours": "Nous sommes ouverts tous les jours de 10h00 à 22h00.",
    "front.faq.chat.answer.reservation": "Oui, vous pouvez réserver une table directement sur notre site ou par téléphone.",
    "front.faq.chat.answer.groupReservation": "Pour les réservations de groupe, veuillez nous contacter directement afin que nous puissions trouver la meilleure option pour vous.",
    "front.faq.chat.answer.address": "Notre adresse est : Musterstraße 1, Berlin.",
    "front.faq.chat.answer.parking": "Oui, des possibilités de stationnement sont disponibles à proximité.",
    "front.faq.chat.answer.phone": "Vous pouvez nous contacter au +49 000 000000.",
    "front.faq.chat.answer.payment": "Oui, vous pouvez payer en espèces ou par carte.",
    "front.faq.chat.answer.menu": "Notre menu actuel est disponible sur le site. Si vous avez des questions sur certains plats, nous serons heureux de vous aider.",
    "front.faq.chat.answer.vegetarian": "Oui, nous proposons des plats végétariens.",
    "front.faq.chat.answer.vegan": "Oui, nous avons également des options véganes dans notre menu.",
    "front.faq.chat.answer.allergens": "Si vous avez des allergies ou des intolérances, veuillez nous contacter directement. Nous vous fournirons les informations sur les ingrédients.",
    "front.faq.chat.answer.takeaway": "Oui, les plats peuvent également être commandés à emporter.",
    "front.faq.chat.answer.delivery": "Pour le moment, le site permet uniquement les réservations et les questions.",
    "front.faq.chat.answer.terrace": "Oui, par beau temps, vous pouvez également vous installer sur notre terrasse.",
    "front.faq.chat.answer.pets": "Veuillez nous contacter directement si vous souhaitez venir avec un animal de compagnie.",
    "front.faq.chat.answer.children": "Oui, les familles avec enfants sont les bienvenues.",
    "front.faq.chat.answer.wifi": "Oui, le Wi-Fi est disponible pour nos clients.",

    "front.acquaintance.callback.placeholder": "Votre numéro de téléphone",
    "front.acquaintance.callback.send": "Envoyer",
    "front.acquaintance.callback.sending": "Envoi...",
    "front.acquaintance.callback.invalidPhone": "Veuillez saisir un numéro de téléphone valide.",
    "front.acquaintance.callback.success": "Demande envoyée. Je vous contacterai bientôt.",
    "front.acquaintance.callback.error": "Erreur lors de l’envoi de la demande. Veuillez réessayer.",

    "front.landingSeo.links.digitalMenu": "Menu numérique pour restaurants",
    "front.landingSeo.links.qrMenu": "Menu avec QR code pour restaurants",
    "front.landingSeo.links.multilingualMenu": "Menu multilingue pour restaurants",
    "front.landingSeo.links.reservation": "Réservation de table en ligne pour restaurants",
    "front.landingSeo.links.freeDigitalMenu": "Tester gratuitement un menu numérique",
    "front.landingSeo.links.changeMenuOnline": "Modifier le menu en ligne",
    
    
    "menu.title": "Menu",
    "menu.promo": "Offres spéciales",
    "menu.empty.categoryTitle": "Renseignez le nom de la catégorie",
    "menu.empty.itemTitle": "Renseignez le nom du produit",
    "menu.empty.itemDescription": "Renseignez la description du produit",
    "cart.add": "Ajouter au panier",
    "cart.cancel": "Annuler",
    "section.video": "Présentation vidéo",
    "section.tables": "RÉSERVATION DE TABLE EN LIGNE",
    "section.table": "CHOISISSEZ UNE TABLE",
    "section.menu": "Menu du restaurant",
    "section.faq": "Questions & réponses",
    "section.contact": "Contact",
    "promo.buy": "Acheter",

    "front.tenant.resolving": "Détection du restaurant par sous-domaine…",
    "front.tenant.notFound": "Aucun client trouvé pour ce sous-domaine",
    "front.tenant.resolveError": "Impossible de déterminer le client",
    "front.menu.loading": "Chargement…",
    "front.menu.loadError": "Erreur lors du chargement du menu",
    "front.menu.addtocart": "Panier",
    "front.menu.cancel": "Annuler",
    "front.Number.servings": "Nombre de portions",

    "orbit.menu": "MENU",
    "orbit.shef": "RÉSERVATION",
    "orbit.video": "VIDÉO",
    "orbit.faq": "QUESTIONS",
    "orbit.interior": "INTÉRIEUR",
    "orbit.footer": "RÉSEAUX SOCIAUX",

    "shef.title.line1": "RÉSERVATION",
    "shef.title.line2": "EN LIGNE",
    "shef.banner.label": "Choisissez",
    "shef.banner.main": "votre table",
    "shef.reserved": "RÉSERVÉ",

    "video.title": "VOICI COMMENT NOUS CUISINONS — AVEC HONNÊTETÉ ET GOÛT",
    "video.add": "Ajouter une vidéo",
    "add.video.but": "Ajouter",

    "interior.title": "NOTRE INTÉRIEUR",

    "footer.kontact": "CONTACTS",

    "telegram.title": "Pour configurer les notifications de commande Telegram, vous devez :",
    "telegram.title.first": "1. Obtenir le BOT_TOKEN",
    "telegram.text.first": "Pour obtenir un BOT_TOKEN, trouvez et lancez le bot @BotFather dans Telegram, envoyez la commande /newbot, suivez les instructions pour créer un nom et un username uniques, puis copiez le token API envoyé par @BotFather.",
    "telegram.title.two": "2. Obtenir le CHAT_ID",
    "telegram.text.two": "Pour obtenir le CHAT_ID, trouvez et lancez le bot @UserInfoBot dans Telegram, envoyez la commande /start, puis copiez l’ID reçu dans la réponse.",

    "cart.title": "VOTRE PANIER",
    "cart.header.aria": "Votre panier",
    "cart.toggle.expand": "Développer le panier",
    "cart.toggle.collapse": "Réduire le panier",
    "cart.total.label": "Total",
    "cart.total.products": "produits",
    "cart.button.primary": "commander",
    "cart.button.back": "retour",
    "cart.button.waiter": "SERVEUR",
    "cart.mode.takeaway": "à emporter",
    "cart.mode.tableTime": "Heure et table",
    "cart.mode.tableTime.disabled": "aucune table libre",
    "cart.mode.tableTime.tooltip": "Heure et table",
    "cart.mode.tableTime.tooltipNoFree": "aucune table libre",
    "cart.mode.inHouse": "sur place",
    "cart.bookingFlow.title": "RÉSERVATION. NUMÉRO DE TABLE",
    "cart.deposit.itemTitle": "Réservation de table (acompte)",
    "cart.deposit.lineTitle": "Acompte",
    "cart.deposit.badge": "Acompte {amount}€",
    "cart.table.msg.tempChosen": "Table {table} temporairement sélectionnée ✓",
    "cart.table.msg.noFree": "Malheureusement, aucune table n’est disponible",
    "cart.table.msg.chooseOrDefault": "Veuillez choisir une table ou conserver la sélection par défaut.",
    "cart.table.select.reserved": "RÉSERVÉ",
    "cart.table.select.pick": "CHOISIR",
    "cart.table.select.any": "N’IMPORTE LAQUELLE",
    "cart.inHouse.title": "CHOISISSEZ VOTRE NUMÉRO DE TABLE",
    "cart.inHouse.select.placeholder": "Choisir une table",
    "cart.inHouse.select.option": "Table #{n}",
    "cart.checkout.back": "Retour",
    "cart.payment.preparing": "Préparation du paiement…",
    "cart.loading": "Chargement…",

    "mockCheckout.title.paymentMethod": "MODE DE PAIEMENT",
    "mockCheckout.method.card": "Carte bancaire",
    "mockCheckout.method.paypal": "PayPal",
    "mockCheckout.method.gpay": "Google Pay",
    "mockCheckout.cardForm.title": "SAISISSEZ LES DONNÉES DE LA CARTE",
    "mockCheckout.cardForm.numberLabel": "NUMÉRO DE CARTE",
    "mockCheckout.error.invalidCardNumber": "Numéro de carte invalide",
    "mockCheckout.error.enter16Digits": "Veuillez saisir 16 chiffres",
    "mockCheckout.error.expiryFormat": "Format MM/AA",
    "mockCheckout.error.expiryMonthRange": "Mois 01–12",
    "mockCheckout.error.cardExpired": "Carte expirée",
    "mockCheckout.error.cvc3Digits": "3 chiffres",
    "mockCheckout.error.sendTelegram": "Erreur lors de l’envoi vers Telegram",
    "mockCheckout.error.generic": "Une erreur est survenue",
    "mockCheckout.reserve.clientNotFound": "Client introuvable",
    "mockCheckout.reserve.tablesNotFound": "Le client n’a pas de section tables",
    "mockCheckout.reserve.tableNotFound": "Table introuvable",
    "mockCheckout.reserve.alreadyReserved": "Cette table vient d’être prise. Veuillez en choisir une autre.",
    "mockCheckout.reserve.noFreeTables": "Aucune table disponible pour le moment",
    "mockCheckout.reserve.tableNotSelected": "Veuillez choisir une table",
    "mockCheckout.reserve.genericError": "Erreur de réservation",
    "mockCheckout.button.back": "retour",
    "mockCheckout.button.pay": "PAYER",
    "mockCheckout.button.sending": "…envoi",
    "mockCheckout.button.paid": "...",
    "mockCheckout.button.payInvalidTitle": "Veuillez vérifier les données de la carte",

    "admin.booking.lead.title": "DÉLAI MINIMUM AVANT RÉSERVATION",
    "admin.booking.lead.note": "Cela concerne uniquement les réservations clients en mode « table et heure ». Le pas est de 30 minutes.",

    "dateTimeStep.select.time": "CHOISISSEZ L’HEURE",

    "admin.title": "PANNEAU D’ADMINISTRATION",
    "admin.loading": "Chargement…",
    "admin.nav.delete": "Supprimer",
    "admin.nav.back": "Retour",
    "admin.nav.next": "SUIVANT",
    "admin.nav.confirm": "ENREGISTRER",
    "admin.nav.confirm.now": "enregistrement ...",
    "admin.booking.settings": "Paramètres de réservation",
    "admin.booking.deposit": "MONTANT DE L’ACOMPTE",
    "admin.booking.deposit.note": "L’acompte est facturé lorsque le client réserve uniquement une table",

    "admin.hub.editmenu": "MODIFIER LE MENU",
    "admin.hub.qr": "QR CODE",
    "admin.hub.prices": "VOTRE TARIF",
    "admin.hub.settings": "PARAMÈTRES",

    "admin.panel.editmenu": "Modification du menu",
    "admin.validation.required": "Champ obligatoire",
    "admin.panel.add": "Ajouter une position",
    "admin.panel.menu": "Modifier la liste du menu",
    "admin.panel.telegram": "Telegram",
    "admin.panel.table": "GESTION DES TABLES",
    "admin.set.table": "Salles / tables",
    "admin.set.logo": "Logo et arrière-plans",
    "admin.logo.successfully.applied": "Logo appliqué avec succès",
    "admin.logo.download.error": "Erreur de téléchargement",
    "admin.settings.number.rooms": "Nombre de salles",
    "admin.settings.room": "Salle",

    "admin.qr.title": "QR code pour les clients",
    "admin.qr.alt": "QR pour le restaurant",
    "admin.qr.copy": "copier le lien",
    "admin.qr.copied": "✓ copié",
    "admin.qr.note": "Les clients peuvent scanner ce code pour ouvrir votre page instantanément.",

    "admin.link.notfound": "Lien introuvable",
    "admin.table.info": "La gestion des tables est disponible sur cette page. Le statut change par pression.",
    "admin.prices.temp": "Les prix sont temporairement indisponibles.",
    "admin.forgot.password": "Mot de passe oublié ?",
    "admin.success.description": "Cliquez sur OK et ajoutez un autre produit",

    "order.success": "Article ajouté au panier !",
    "order.error": "Cet article est déjà dans le panier",

    "popap.product.removal": "Suppression du produit",
    "popap.category.removal": "Suppression d’une catégorie",
    "popap.want.delete.product": "Êtes-vous sûr de vouloir supprimer le produit",
    "popap.want.delete.category": "Êtes-vous sûr de vouloir supprimer la catégorie ?",

    "admin.settings.guestLang": "Langue par défaut pour les clients",
    "admin.settings.adminLang": "Langue par défaut pour l’admin",
    "admin.settings.noteGuest": "Cette langue sera définie par défaut lorsque les clients ouvriront la page.",
    "admin.settings.noteAdmin": "Cette langue sera définie par défaut dans l’espace admin.",
    "admin.language": "Langue",
    "admin.settings.logo": "Logo de l’établissement",
    "admin.settings.logo.text": "Téléchargez votre logo (PNG/JPG/WEBP/SVG, jusqu’à 2 Mo). Cliquez ensuite sur « Enregistrer », cela remplacera le logo actuel par le nouveau.",
    "admin.settings.backtable": "Image d’arrière-plan sur l’écran de sélection des tables",
    "admin.settings.backhome": "Image d’arrière-plan de l’écran d’accueil",
    "admin.settings.backtable.text": "Téléchargez une image d’arrière-plan (SVG/PNG/JPG/WEBP). Cliquez ensuite sur « Enregistrer », cela remplacera l’arrière-plan actuel par le nouveau.",
    "admin.settings.language.visitors": "Langue principale pour les visiteurs de l’établissement",
    "admin.settings.language.visitors.text": "Cette langue sera définie comme langue principale lorsque les clients ouvrent la page",
    "admin.settings.language.admin": "Langue principale de votre panneau d’administration",
    "admin.settings.language.admin.text": "Cette langue sera définie par défaut à l’ouverture du panneau d’administration",
    "admin.settings.gallery": "Galerie",
    "admin.settings.social": "Réseaux sociaux",
    "admin.settings.number.tables": "Nombre de tables",
    "admin.settings.how.many.tables": "Combien de tables y a-t-il dans l’établissement ?",
    "admin.settings.tables.test": "Enregistrez le nombre de tables puis revenez à l’onglet précédent pour configurer chaque table séparément",
    "admin.settings.upload.panoramic": "Téléchargez une image panoramique de la salle de votre établissement",
    "admin.settings.table": "Table",
    "admin.settings.table.not.found": "Table introuvable",
    "admin.settings.contact.details": "Coordonnées",
    "admin.contacts.company": "Nom de l’entreprise",
    "admin.contacts.address": "Adresse",
    "admin.contacts.phone": "Numéro de téléphone",
    "admin.socials.title": "Réseaux sociaux",
    "admin.settings.rooms.hint": "Veuillez indiquer le nombre de salles de l’établissement",

    "admin.settable.title": "Étape 3. Numérotation des tables",
    "admin.settable.text1": "Chaque étiquette a un numéro ; placez les étiquettes selon les numéros des tables.",
    "admin.settable.text2": "Utilisez le bouton pour modifier la taille de l’étiquette.",
    "admin.settable.text3": "Enregistrez les données de la table actuelle et cliquez sur l’icône correspondante pour passer d’une table à l’autre.",
    "admin.setqr.title": "Vos QR codes",
    "admin.setqr.text1": "vos messages, menus et QR codes sont enregistrés sur cette page",
    "admin.setqr.text2": "l’achat d’un tarif BASIC génère automatiquement un QR code et un lien vers votre sous-domaine, par exemple example.best-place.club",
    "admin.setqr.text3": "vous pouvez suivre le lien, le copier et enregistrer le QR code comme image sur votre appareil",
    "admin.setpanorama.title": "Étape 2. Image panoramique",
    "admin.setpanorama.text1": "Ajoutez une image panoramique. Il est recommandé d’utiliser des fichiers légers, par exemple au format WEBP.",
    "admin.setpanorama.text2": "Si l’image est téléchargée avec succès, vous la verrez dans l’aperçu ci-dessous.",
    "admin.setnumber.title": "Étape 1. Nombre de tables",
    "admin.setnumber.text1": "Choisissez le nombre de tables dans votre établissement",
    "admin.setnumber.text2": "Il est recommandé de commencer avec une ou deux tables, puis d’augmenter leur nombre.",

    "admin.current.logo": "Logo actuel",
    "admin.add.photo": "vous pouvez ajouter un fichier ici",
    "admin.add.file": "formats de fichiers acceptés : .xlsx, .xls, .csv",
    "admin.add.file.but": "Ajouter un fichier",
    "admin.import.format": "Format des colonnes : Catégorie / Titre / Description / Prix",
    "admin.import.follow": "respectez le format de colonnes indiqué et préparez un fichier au format correspondant",
    "admin.import.BeСareful": "Attention : les données précédentes seront perdues lors de l’import",
    "admin.add.photo.but": "Ajouter une photo",
    "admin.add.photo.set": "Ajouter une photo",

    "admin.wizard.step1": "Choisir une catégorie",
    "admin.wizard.step2": "Nom et prix",
    "admin.wizard.step3": "Description et photo",
    "admin.wizard.ready": "Prêt",
    "admin.wizard.defaultTitle": "Ajouter un produit",
    "admin.wizard.step1.desc": "Étape 1. Choisissez une catégorie existante ou créez-en une nouvelle",
    "admin.wizard.step2.desc": "Étape 2. Indiquez le nom du produit dans les langues nécessaires et fixez le prix",
    "admin.wizard.step3.desc": "Étape 3. Rédigez la description du produit, ajoutez une image et cliquez sur enregistrer",
    "admin.wizard.step1.desc.short": "Étape 1. Choisissez une catégorie existante ou nouvelle",
    "admin.wizard.step2.desc.short": "Étape 2. Ajoutez le nom et le prix du produit",
    "admin.wizard.step3.desc.short": "Étape 3. Décrivez le produit et ajoutez une photo",
    "admin.wizard.tab.existing": "Existante",
    "admin.wizard.tab.new": "Nouvelle",
    "admin.wizard.cat.loading": "Chargement…",
    "admin.wizard.cat.empty": "Aucune catégorie pour le moment. Passez à « Nouvelle » et créez la première.",

    "admin.form.categoryKeyDe": "Catégorie (KEY/DE)",
    "admin.form.categoryEn": "Catégorie (EN)",
    "admin.form.titleMain": "Nom du produit",
    "admin.form.descMain": "Description du produit",
    "admin.validation.req": "Entrez le nom du produit",
    "admin.form.titleDe": "Titre (DE)",
    "admin.form.titleEn": "Titre (EN)",
    "admin.form.nameDe": "Nom (DE)",
    "admin.form.nameEn": "Nom (EN)",
    "admin.form.price": "Prix",
    "admin.form.descDe": "Description (DE)",
    "admin.form.descEn": "Description (EN)",

    "admin.toast.productAdded": "Produit ajouté avec succès",
    "admin.tooltip.fixFormErrors": "Corrigez les erreurs du formulaire",

    "admin.validation.firstCharNotDigit": "Le premier caractère ne peut pas être un chiffre.",
    "admin.validation.maxChars": "raccourcissez le nom du produit",
    "admin.validation.chooseCategory": "Choisissez une catégorie.",
    "admin.validation.chooseCategoryFromList": "Choisissez une catégorie dans la liste.",
    "admin.validation.enterCategoryName": "Saisissez un nom de catégorie.",
    "admin.validation.enterProductName": "Saisissez un nom de produit.",
    "admin.validation.priceFormat": "Format de prix invalide (par ex. 12.50)",
    "admin.validation.enterDescription": "Saisissez une description.",
    "admin.tarif.apply": "appliquer",
    "admin.menu.creating": "Créer le menu",
    "admin.choose.template": "Étape 1 : choisissez un modèle",
    "admin.choose.template2": "Étape 2 : vérifiez les lignes de produits",
    "admin.choose.atyle": "Choisissez un style de menu. Vous pourrez le modifier plus tard",

    "admin.error.tenantNotFound": "Aucun client trouvé pour ce sous-domaine.",
    "admin.error.resolveClient": "Impossible de déterminer le client.",
    "admin.error.menuLoad": "Impossible de charger le menu.",
    "admin.error.saveLang": "Impossible d’enregistrer la langue.",
    "admin.error.clientNotFound": "Client introuvable sur le serveur",
    "admin.error.arrNotFound": "Tableau de données introuvable pour ce client",

    "tpl.premium.title": "Premium",
    "tpl.classic.title": "Classique",
    "tpl.dark.title": "Sombre",
    "tpl.minimal.title": "Minimal",
    "tpl.premium.desc": "Meilleure vente",
    "tpl.classic.desc": "clair",
    "tpl.dark.desc": "sombre",
    "tpl.minimal.desc": "minimal",

    "tp2.position.total": "Vous avez maintenant :",
    "tp2.position.punkte": "éléments de menu",
    "tp2.position.template": "Modèle",

    "tp3.qr.link": "QR code et lien du menu",
    "tp3.step3.title": "Étape 3 : aperçu / publication",
    "admin.tp.progres.publication": "Publication",
    "admin.tp.progres.positionen": "Positions",

    "tp4.link.copy": "COPIER",
    "tp4.link.copy.ok": "✓ COPIÉ",

    "admin.tp.publish": "Publier",
    "admin.tp.posting": "publication ...",

    "admin.import.from.excel": "Importer le menu depuis Excel",

    "popap.successful.payment": "Paiement réussi",

    "landing.title": "Solutions numériques pour restaurants",
    "landing.title.login": "Se connecter",
    "landing.text": "Lancez le site de votre restaurant en quelques minutes !",
    "landing.try.now": "essayer gratuitement",
    "landing.title.to": "À qui notre service convient-il ?",
    "landing.title.answer": "Il est avant tout utile aux propriétaires d’établissements dont l’objectif est d’attirer de nouveaux clients et de fidéliser les clients existants",
    "landing.content.title.first": "Menu en ligne avec QR code",
    "landing.content.first": "Vos visiteurs ont accès à un menu et à des prix à jour simplement en scannant le QR code, et les offres spéciales renforcent leur fidélité à votre produit",
    "landing.content.title.second": "Réservation de tables en ligne",
    "landing.content.second": "Nous proposons à vos clients une réservation visuelle en ligne avec des images panoramiques supplémentaires. Si nécessaire, ils peuvent passer entre les zones voisines",
    "landing.content.title.third": "Contenu atmosphérique",
    "landing.content.third": "Vos visiteurs potentiels peuvent consulter différents contenus : photos de l’intérieur, vidéos de préparation des plats phares et vue panoramique de la salle.",
    "landing.content.title.four": "Augmentez le ticket moyen",
    "landing.content.four": "Proposez à vos clients des banquets, anniversaires ou offres spéciales pour des commandes complexes ou quotidiennes",
    "landing.request": "Nous vous contacterons bientôt",
    "callback.invalidPhone": "Veuillez saisir un numéro de téléphone valide",
    "landing.enter.number": "VOTRE NUMÉRO",
    "callback.submitError": "Le numéro n’a pas pu être envoyé. Veuillez réessayer",
    "landing.tariff.advance": "Avertissement",
    "landing.tariff.advance.desc": "Dans le cadre du tarif sélectionné, vous pouvez remplir gratuitement votre application avec du contenu",
    "landing.tariff.one-time-not-included": "Calcul individuel du prix. Un bouton de contact se trouve dans le coin droit de l’écran. Laissez votre numéro et nous vous contacterons",
    "landing.tariff.one-time-services": "Services ponctuels",
    "landing.tariff.logo-creation": "Création de logo",
    "landing.tariff.selling-images": "Création d’images produits vendeuses",
    "landing.tariff.panorama-creation": "Création de panorama",

    "demo.video.unsupported": "Votre navigateur ne prend pas en charge la vidéo",
    "demo.title.after": "aperçu du service",
    "demo.title.accent": "court",
    "demo.title.before": "Un",
    "demo.title.total": "du service",
    "demo.title": "Aperçu vidéo",

    "landing.free.first": "Menu en ligne via QR code disponible, résultat en quelques minutes.",
    "landing.free.second": "Possibilité de modifier le menu pour la date actuelle",
    "landing.free.third": "Accès au créateur de design du menu",
    "landing.basic.first": "Page URL complète avec accès au menu via QR code",
    "landing.basic.second": "Commande en ligne pour vos visiteurs",
    "landing.basic.third": "Réservation de tables en ligne, photos panoramiques de votre salle, tables cliquables et affichage en temps réel des tables réservées et disponibles",
    "landing.basic.fourth": "Menu avec traduction dans toutes les langues",
    "landing.pro.first": "Fonctionnalités pour gérer les offres de prix, créer des bannières et développer des stratégies marketing",
    "landing.pro.second": "Possibilité de gérer le système de fidélisation des clients de l’établissement et d’influencer le résultat des avis Google",
    "landing.pro.third": "",
    "landing.title.free": "Gratuit pendant 14 jours",
    "landing.registerTitle": "Inscription",
    "landing.tariff.selection": "Choix du tarif",
    "landing.tariff.subdomain": "Enregistrement du sous-domaine",
    "landing.tariff": " / par mois",
    "landing.your.tariff": "votre tarif",
    "landing.your.example": "par exemple",
    "landing.Subdomain.selection": "Choix du sous-domaine",
    "landing.password": "mot de passe",
    "landing.tariff.free": "GRATUIT",
    "landing.tariff.free-description": "pour découvrir le service",
    "landing.tariff.basic": "BASIC",
    "landing.tariff.basic-description": "fonctions de base pour démarrer",
    "landing.tariff.pro": "PRO",
    "landing.tariff.pro-description": "pour utilisateurs avancés",
    "landing.tariff.selected": "✓ sélectionné",
    "landing.legal.text.start": "J’accepte les",
    "footer.legal.terms": "Conditions",
    "landing.legal.text.mid": "et la",
    "landing.tariff.optional": "Services ponctuels",
    "landing.tariff.one-time-note": "Voir les tarifs pour la création d’images vendeuses de haute qualité",
    "landing.tariff.pro-locked-desc": "Ce tarif n’est pas encore disponible",
    "landing.tariff.in-development": "En développement",
    "landing.tariff.free-one-time-desc": "pour remplir votre menu avec des images de haute qualité",

    "footer.legal.privacy": "Politique",
    "footer.legal.privacy.and": "de confidentialité",
    "footer.about": "Plateforme pour restaurants : menu, réservations de tables, commandes et panneau d’administration.",

    "server.common.unknown": "Erreur inconnue.",
    "server.common.serverError": "Erreur interne du serveur.",
    "server.common.networkError": "Erreur réseau. Veuillez réessayer.",
    "server.common.clientIdMissing": "Erreur : clientId manquant.",

    "server.login.required": "Email et mot de passe requis.",
    "server.login.invalidCredentials": "Email ou mot de passe incorrect.",
    "server.login.signupIncomplete": "Le compte n’est pas encore actif. Terminez l’inscription.",
    "server.login.success": "Connexion réussie !",

    "server.register.required": "Email et mot de passe requis.",
    "server.register.emailExistsActive": "Un utilisateur avec cet email existe déjà. Utilisez la connexion.",
    "server.register.resume": "Poursuite de l’inscription.",
    "server.register.success": "Inscription réussie !",

    "server.signupComplete.success": "Activation réussie !",
    "server.signupComplete.error": "Échec de l’activation.",

    "server.subdomain.required": "clientId et sous-domaine sont requis.",
    "server.subdomain.planInvalid": "Tarif invalide. Autorisé : free | basic | pro.",
    "server.subdomain.invalid": "Sous-domaine invalide (a-z, 0-9, '-', 3–30, pas de '-' au début/à la fin).",
    "server.subdomain.reserved": "Ce sous-domaine est réservé.",
    "server.subdomain.taken": "Ce sous-domaine est déjà pris.",
    "server.subdomain.userNotFound": "Utilisateur introuvable.",
    "server.subdomain.success": "Sous-domaine enregistré. Redirection…",
    "server.subdomain.error": "Échec de l’enregistrement du sous-domaine.",

    "landing.loginTitle": "Connexion",
    "landing.btn.login": "Connexion",
    "landing.btn.register": "Inscription",
    "landing.btn.enter": "Entrer",
    "landing.loggingIn": "Connexion…",
    "landing.registering": "Inscription…",
    "landing.activating": "Activation…",
    "landing.subdomain.registering": "Enregistrement du sous-domaine…",
    "landing.redirecting": "Redirection…",
    "landing.legal.required": "Veuillez accepter les Conditions et la Politique de confidentialité.",

    "landing.subdomain.err.empty": "Veuillez saisir un sous-domaine.",
    "landing.subdomain.err.chars": "Uniquement lettres, chiffres et '-', 3–30 caractères.",
    "landing.subdomain.err.hyphen": "Le sous-domaine ne peut pas commencer ou se terminer par '-'.",
    "landing.subdomain.err.reserved": "Ce sous-domaine est réservé.",

    "admin.menuLanguages.title": "Langues du menu",
    "admin.menuLanguages.default": "La langue que verra en premier un visiteur de votre établissement (par défaut)",
    "admin.menuLanguages.hint": "Sélectionnez les langues qui seront utilisées en complément",
    "common.success": "Réussi",
    "admin.import.activeLangs": "Langues du menu actif",
    "admin.import.sourceLangHint": "Le texte Excel ne sera rédigé que dans la langue sélectionnée. Les champs des autres langues actives resteront vides",
    "admin.import.sourceLang": "Spécifiez la langue dans laquelle le fichier Excel est écrit",
    "admin.import.mainLang": "le principal",
    "booking.date.today": "Aujourd’hui",
    "booking.date.tomorrow": "Demain",
    "booking.room": "Salle",

    "front.faq.chat.answer.greeting": "Bonjour ! Je peux vous aider avec les réservations, le menu, l’adresse, les horaires d’ouverture et d’autres questions.",
"front.faq.chat.answer.howAreYou": "Merci, je vais bien ! Comment puis-je vous aider concernant le restaurant ?",
"front.faq.chat.answer.thanks": "Avec plaisir ! N’hésitez pas à poser d’autres questions si besoin.",
"front.faq.chat.answer.goodbye": "Au revoir ! Nous serons ravis de vous accueillir.",
"front.faq.chat.answer.whoAreYou": "Je suis l’assistant numérique du restaurant. J’aide les clients avec les questions fréquentes.",
"front.faq.chat.answer.help": "Je peux vous aider avec les réservations, le menu, l’adresse, le numéro de téléphone, le paiement, les allergènes, la livraison et d’autres questions.",
"front.faq.chat.answer.recommendation": "Je vous conseille de consulter le menu — vous y trouverez les plats actuels et pourrez choisir ce qui vous convient le mieux.",
"front.faq.chat.answer.compliment": "Merci beaucoup ! Cela nous fait très plaisir.",

"checkout.button.send": "ENVOYER",
"checkout.button.sending": "Envoi en cours ...",
"checkout.button.sent": "Envoyé",
"checkout.title.order": "COMMANDE",
"checkout.phone.title": "Entrez votre numéro de téléphone",
"checkout.phone.label": "Numéro de téléphone",

"footer.workingHours": "Horaires de travail",

"admin.offline.title": "Pas de connexion Internet",
"admin.offline.text": "Vérifiez votre connexion Internet. Vous pourrez reprendre automatiquement votre travail dès que la connexion sera rétablie.",
"admin.offline.status": "En attente de connexion…",

  };

export default fr;